import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { SecurityService } from "../../service/security.service";
@Component({
  selector: "app-sso-logout",
  templateUrl: "./sso-logout.component.html",
  styleUrls: ["./sso-logout.component.scss"],
})
export class SsoLogoutComponent implements OnInit {
  constructor(
    private router: Router,
    private securityService: SecurityService,
  ) {}

  ngOnInit(): void {}
  login(): void {
    this.router.navigate(["/", "login"]);
  }
}
